import {DateTime, DateTimeOptions} from "luxon";
import {toast} from "react-toastify";

/**
 *
 * @param date
 * @param format
 */
export const formatDate = (date: string | null | undefined, format?: DateTimeOptions | null | undefined) => {
    return date ? DateTime.fromISO(date).toLocaleString(format ?? DateTime.DATETIME_MED) : "";
}

export const formatBytes = (bytes: number | undefined | null, decimals = 2): string => {
    if (bytes === 0) return "0 B"
    if(!bytes) return "unknown"

    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
}

/**
 *
 * @param str
 */
export const capitalise = (str: string) => {
    if(str.length === 0) return str
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 *
 * @param c
 */
export const nextChar = (c: string)=> {
    return String.fromCharCode(c.charCodeAt(0) + 1);
}

/**
 *
 * @param index
 */
export const indexChar = (index: number) => {
    const a = "a".charCodeAt(0);
    return String.fromCharCode(a + index);
}

/**
 *
 * @param num
 */
export const toRoman = (num: number) => {
    const numerals = [
        { value: 1000, numeral: 'M' },
        { value: 900, numeral: 'CM' },
        { value: 500, numeral: 'D' },
        { value: 400, numeral: 'CD' },
        { value: 100, numeral: 'C' },
        { value: 90, numeral: 'XC' },
        { value: 50, numeral: 'L' },
        { value: 40, numeral: 'XL' },
        { value: 10, numeral: 'X' },
        { value: 9, numeral: 'IX' },
        { value: 5, numeral: 'V' },
        { value: 4, numeral: 'IV' },
        { value: 1, numeral: 'I' }
    ];

    let result = '';

    for (const { value, numeral } of numerals) {
        while (num >= value) {
            result += numeral;
            num -= value;
        }
    }

    return result;
}

export const copyToClipboard = (text: string, notification?: string) => {
    navigator.clipboard.writeText(text)
    if(notification !== undefined) {
        if(notification) toast.success(notification)
        return
    }

    toast.success("Copied to clipboard")
}

export const trimString = (str: string, len: number = 20) => {
    if(!(str.length >= len)) return str;

    return str.slice(0, len) + '…';
}

/**
 * Make a string universally filename‑friendly.
 *
 * @param {string} raw The original text (e.g. a title).
 * @param {Object} [options] Optional tweaks.
 * @param {number} [options.maxLen] Maximum length of the result (default 255).
 * @param {boolean}[options.lower] Force lower‑case (default true).
 * @returns {string} A safe, trimmed, hyphen‑separated filename.
 */
export const filenameFrom = (raw: string, { maxLen = 255, lower = true } = {}) => {
    let s = raw.normalize('NFKD');

    if (lower) s = s.toLowerCase();

    s = s.replace(/\s+/g, '-');

    const illegalChars = /[<>:"/\\|?*\x00-\x1F]/g; // \x00‑\x1F = C0 control range
    s = s.replace(illegalChars, '');
    s = s.replace(/[^A-Za-z0-9._-]+/g, '-');
    s = s.replace(/[-]+/g, '-');
    s = s.replace(/[.]+/g, '.');
    s = s.replace(/^[-. ]+|[-. ]+$/g, '');

    const reserved = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i;
    if (reserved.test(s)) s = '_' + s;

    if (s.length > maxLen) s = s.slice(0, maxLen);

    return s;
}
